<template>
<div class="trend-related-chart-group" :style="{
  '--related-chart-width': relatedChartWidth
}">
  <dimension-weather-chart
    v-if="hasAllWindFactor"
    ref="chart"
    :data-config="dataConfig"
    :dimension="0"
    :unit-prop="unitProp"
    :download-name="downloadName"
    :chart-height="chartHeight"
  />
  <x-y-chart
    v-else
    ref="chart"
    :data-config="dataConfig"
    :unit-prop="unitProp"
    :chart-type="chartType"
    :stack-type="stackType"
    :download-name="downloadName"
    :chart-height="chartHeight"
    selected-change-with-data-changed
  />

  <div class="related-chart-container">
    <div v-if="dimensions.length <= 2" class="related-chart-header">
      <span>{{dimensionMap[selectedDimensionIds[0]].name}}</span>
      <span>VS</span>
      <span>{{dimensionMap[selectedDimensionIds[1]].name}}</span>
    </div>

    <div v-else class="related-chart-header">
      <el-select
        v-model="selectedDimensionIds[0]"
        size="small"
        style="width:120px;"
      >
        <el-option
          v-for="dimension in dimensions"
          :key="dimension.id"
          :value="dimension.id"
          :label="dimension.name"
        />
      </el-select>

      <span>VS</span>

      <el-select
        v-model="selectedDimensionIds[1]"
        size="small"
        style="width:120px;"
      >
        <el-option
          v-for="dimension in dimensions"
          :key="dimension.id"
          :value="dimension.id"
          :label="dimension.name"
        />
      </el-select>
    </div>

    <div>
      <related-chart
        :base-data="relatedData[0]"
        :related-data="relatedData[1]"
        :audit-rule-map="auditRuleFlagMap"
        :scale="scale"
        @dblclick="onRelatedChartDBLClick"
      />
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'

import XYChart from '../DataChart/XYChart'
import RelatedChart from './RelatedChart'
import DimensionWeatherChart from './ChartWrapper/DimensionWeatherChart'

export default {
  name: 'TrendRelatedChart',
  components: {DimensionWeatherChart, XYChart, RelatedChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    chartHeight: {
      type: String,
      default: 'auto'
    },
    downloadName: {
      required: true,
      type: String
    },
    relatedChartWidth: {
      type: String,
      default: '418px'
    },
    clickAble: {
      type: Boolean
    },
    scale: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chartType: 'line',
      stackType: 0,
      selectedDimensionIds: []
    }
  },
  computed: {
    ...mapGetters({
      auditRuleFlagMap: 'AuditRule/flagMap'
    }),
    hasAllWindFactor () {
      const windFactorIds = this.dataConfig.dimensions.reduce((list, dimension) => {
        const {factorId} = dimension

        if (/^(1012|1013)$/.test(factorId)) {
          list.push(factorId)
        }

        return list
      }, [])

      return windFactorIds.includes('1012') && windFactorIds.includes('1013')
    },
    dimensions () {
      return this.dataConfig.dimensions
    },
    dimensionMap () {
      return this.dimensions.reduce((map, dimension) => {
        map[dimension.id] = dimension
        return map
      }, {})
    },
    seriesMap () {
      return this.dataConfig.seriesMap
    },
    dataTimes () {
      return this.dataConfig.dataTimes
    },
    relatedData () {
      let {dimensionMap, seriesMap, dataTimes, unitProp} = this
      return this.selectedDimensionIds.map(dimensionId => {
        let dimension = dimensionMap[dimensionId]
        let series = seriesMap[dimensionId]

        return {
          id: dimensionId,
          name: dimension.name,
          unit: dimension[unitProp],
          data: dataTimes.map(dataTimeObj => {
            let dataTime = dataTimeObj[1]
            let data = series[dataTime]
            return data || {
              dataTime,
              value: null
            }
          })
        }
      })
    }
  },
  methods: {
    setSelectedDimensionIds (dimensions) {
      this.selectedDimensionIds = [dimensions[0].id, dimensions[Math.max(Math.min(1, dimensions.length - 1), 0)].id]
    },
    onRelatedChartDBLClick (chartData) {
      // if (!this.clickAble) {
      //   return
      // }

      // let {dataTimes, dimensions, seriesMap, auditRuleFlagMap, dataConfig} = this
      // let {dataTime} = chartData[4]
      // let index = dataTimes.findIndex(dataTimeObj => dataTimeObj[1] === dataTime)
      // let start = Math.max(0, index - 5)
      // let end = Math.min(dataTimes.length, start + 11)
      // start = Math.max(0, end - 11)

      // this.$emit('dblclick', Object.freeze({
      //   id: dataConfig.id,
      //   name: dataConfig.name,
      //   dataTime,
      //   dataList: Object.freeze(dataTimes.slice(start, end).map(([ts, dataTime]) => dimensions.reduce((map, dimension) => {
      //     let dimensionId = dimension.id
      //     let series = seriesMap[dimensionId]
      //     let data = series[dataTime]

      //     if (data) {
      //       let {flag} = data
      //       map[dimensionId] = `${data.value}${flag ? `(${auditRuleFlagMap[flag] ? auditRuleFlagMap[flag].name : '正常'})` : ''}`
      //     } else {
      //       map[dimensionId] = '--'
      //     }

      //     return map
      //   }, {
      //     dataTime,
      //     ts
      //   })))
      // }))
    },
    getChartComponent () {
      return this.$refs.chart.getChartComponent()
    }
  },
  watch: {
    dimensions (dimensions) {
      this.setSelectedDimensionIds(dimensions)
    }
  },
  created () {
    this.setSelectedDimensionIds(this.dimensions)
  }
}
</script>

<style lang="scss" scoped>
.trend-related-chart-group {
  display: grid;
  grid-template-columns: auto var(--related-chart-width);

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .related-chart-container {
    display: grid;
    grid-template-rows: 40px var(--related-chart-width);
    grid-row-gap: 12px;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > .related-chart-header {
      font-size: 22px;
      display: grid;
      grid-template-columns: repeat(3, max-content);
      grid-column-gap: .5em;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TrendRelatedChart.vue